<template>
  <div class="groupCodeDialog">
    <el-dialog
      :title="title"
      :visible.sync="open"
      :close-on-click-modal="true"
      width="550px"
      center
    >
      <div class="groupCodeDialog-box">
        <div class="prompt">入组二维码</div>
        <img class="code-img" :src="image" alt="" />
        <div class="characters">
          请将该二维码发送给需要入组的医生、运营人员 通过微信扫码加入当前分组
        </div>
        <el-button class="btn" type="primary" :disabled="!image" @click="download_image" >下载图片</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "groupCodeDialog",
  props: {
    value: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    image: {
      type: String,
      default: () => ""
    },
    title: {
      type: String,
      default: () => ""
    }
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  methods: {
    download_image() {
      let a = document.createElement("a");
      a.href = this.image;
      a.download = "二维码";
      a.click();
    },
  }
};
</script>
<style lang="scss" scoped>
.groupCodeDialog-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding:  0 102px;
  gap: 25px;
  .prompt{
    font-size: 18px;
    color: #3F3F3F;
  }
  .code-img{
    width: 285px;
    height: 263px;
    border-radius: 5px;
    border: 1px solid #D9D9D9;
    padding: 10px;
    object-fit: contain;
  }
  .characters{
    text-align: center;
    font-size: 16px;
    color: #3F3F3F;
  }
  .btn{
    width: 90px;
    height: 36px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
::v-deep .el-dialog__header {
  padding-top: 40px;
}
::v-deep .el-dialog__title{
  font-size: 32px;

}
</style>
